import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import XLSX from 'xlsx'

//引入所有插件  位于 plugins/index.js
import './plugins'

// 基础样式
import './assets/style/index.css'

Vue.config.productionTip = false
Vue.config.devtools = true;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

//导入导出
/**
 * 导入
 * @param {*} file
 */
 const readExcel = (file) => {
  return new Promise(function(resolve, reject) {
    const fileReader = new FileReader()
    fileReader.onload = (ev) => {
      try {
        const data = ev.target.result
        const workbook = XLSX.read(data, { type: 'binary', })
        for (let sheet in workbook.Sheets) {
          var result = XLSX.utils.sheet_to_json(workbook.Sheets[sheet], { defval: '' })
          resolve(result)
          break
        }
      } catch (e) {
        return false
      }
    }
    fileReader.readAsBinaryString(file.raw)
  })
}

/**
 * 导出
 * @param {*} data      导出数据集合
 * @param {*} title     导出excel标题集合
 * @param {*} fileName  文件名称
 */
const exportData = (data, title, fileName) => {
  const ws = XLSX.utils.json_to_sheet(data, title)
  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, ws, fileName)
  XLSX.writeFile(wb, fileName + ".xlsx")
}
Vue.prototype.$readExcel = readExcel
Vue.prototype.$exportData = exportData
